// Performance-recorder UI: the drawer Record button and the floating "⏺ REC m:ss" badge.
// Kept out of controls.ts (size cap) and decoupled from the renderer — the badge is a fixed
// DOM overlay, like the MIDI-warning card. State is pushed in by main.ts.
import { el } from "./dom";

interface RecordControl {
  /** The drawer row (a single toggle button). */
  row: HTMLElement;
  /** `recording` flips the label; `enabled` gates starting (needs a MIDI device) — a live
   *  recording can always be stopped. */
  setState(recording: boolean, enabled: boolean): void;
}

export function buildRecordControl(onToggle: () => void): RecordControl {
  const btn = el<HTMLButtonElement>("button", { textContent: "⏺ Record" });
  btn.onclick = onToggle;
  return {
    row: btn,
    setState(recording, enabled) {
      btn.textContent = recording ? "⏹ Stop & download" : "⏺ Record";
      btn.disabled = !recording && !enabled;
      btn.classList.toggle("recording", recording);
    },
  };
}

interface RecordBadge {
  set(visible: boolean, label: string): void;
}

/** A fixed-position recording indicator appended to `parent` (hidden until shown). */
export function createRecordBadge(parent: HTMLElement): RecordBadge {
  const badge = el<HTMLDivElement>("div", { class: "rec-badge" });
  badge.style.display = "none";
  parent.append(badge);
  return {
    set(visible, label) {
      badge.style.display = visible ? "" : "none";
      badge.textContent = label;
    },
  };
}
